import { BrowserRouter, Navigate, Route, Routes, useParams } from "react-router-dom";
import React, { useState } from "react";

import AboutUs from "pages/about-us";
import CompanyPermissions from "pages/company-permissions";
import CompanyDirectory from "pages/company-directory";
import ContactUs from "pages/contact-us";
import CreateProject from "pages/create-project";
import Footer from "components/footer";
import ForgetPassword from "pages/forget-password";
import HandleAuthData from "pages/handle-auth-data";
import Home from "pages/home";
import KoncurentSupport from "pages/Koncurent-Support";
import Login from "pages/login";
import NavbarComponent from "components/navbar";
import Permissions from "pages/permissions";
import ProjectContacts from "pages/project-contacts";
import Reports from "pages/canned-reports";
import ReportsDetails from "pages/reports-details";
import ProjectPermissions from "pages/project-permissions";
import Projects from "pages/projects";
import ResetPassword from "pages/reset-password";
import UserPermissionTable from "pages/user-permission";
import VerifyCode from "pages/verify-code";
import RegisterClient from "pages/registering-new-client";
import DeletedItems from "pages/deleted-items";
import HiddenItems from "pages/hidden-items";
import CompanyAdmin from "pages/company-admin";
import CompanyOverview from "pages/company-overview";
import CompanySchedule from "pages/company-schedule";
import CompanyReports from "pages/company-reports";
import CompanyDashboard from "pages/company-dashboard";
import CompanyReportsDetails from "pages/company-reports-details";
import ProjectReports from "pages/project-reports";
import ProjectCustomReport from "pages/project-custom-reports";
import CustomReportsDetails from "pages/custom-reports-details";
import CreateUpdateCustomReports from "pages/create-update-custom-reports";
import Dashboard from "pages/dashboard";
import FlaggedItems from "pages/flagged-items";
import CreatePassword from "pages/create-password";
import ContractorSubmittals from "pages/contractor-submittal";
import SidePanelSubmittals from "pages/sidepanel-submittal";
import WareHouse from "pages/warehouse";
import WarehouseDashboard from "pages/warehouse-dashboard";
import WarehouseInventory from "pages/warehouse-inventory";
import WarehouseJobSites from "pages/warehouse-job-sites";
import WarehouseTransfers from "pages/warehouse-transfers";
import WarehouseSettings from "pages/warehouse-settings";
import WarehousePurchasedOrders from "pages/warehouse-purchased-orders";
import WarehouseReports from "pages/warehouse-reports";
import WarehouseReportsDetails from "pages/warehouse-reports-details";
import ViewDependencies from "pages/view-dependencies";
import Hilyte from "pages/hilyte";
import ProcurementLog from "pages/procurement-log";

const ProcurementLogCanonicalRedirect = () => {
  const { company_id, id } = useParams();

  return (
    <Navigate
      to={`/main/company/${company_id}/projects/${id}`}
      replace
    />
  );
};

const Router = () => {
  return (
    <>
      <BrowserRouter basename="/">
        <NavbarComponent />
        <Routes>
          {/* main routes */}
          <Route
            exact
            path="/main/company/:company_id/company-admin"
            element={<CompanyAdmin />}
          ></Route>
          <Route
            exact
            path="/main/company/:company_id/company-reports"
            element={<CompanyReports />}
          ></Route>
          <Route
            exact
            path="/main/company/:company_id/company-reports/:reportName"
            element={<CompanyReportsDetails />}
          ></Route>
          <Route
            exact
            path="/main/company/:company_id/projects"
            element={<Projects />}
          ></Route>
          <Route
            exact
            path="/main/company/:company_id/permissions"
            element={<Permissions />}
          ></Route>
          <Route
            exact
            path="/main/company/:company_id/create-project/:id"
            element={<CreateProject />}
          ></Route>
          <Route
            exact
            path="/main/company/:company_id/projects/:id"
            element={<ProcurementLog />}
          ></Route>
          <Route
            exact
            path="/main/company/:company_id/beta-projects/:id/*"
            element={<ProcurementLogCanonicalRedirect />}
          ></Route>
          <Route
            exact
            path="/main/company/:company_id/projects/:id/legacy/*"
            element={<ProcurementLogCanonicalRedirect />}
          ></Route>
          <Route
            exact
            path="/main/company/:company_id/projects/:id/dashboard"
            element={<Dashboard />}
          ></Route>
          <Route
            exact
            path="/main/company/:company_id/projects/:id/directory"
            element={<ProjectContacts />}
          ></Route>
          <Route
            exact
            path="/main/company/:company_id/projects/:id/deleted-items"
            element={<DeletedItems />}
          ></Route>
          <Route
            exact
            path="/main/company/:company_id/projects/:id/hidden-items"
            element={<HiddenItems />}
          ></Route>
          <Route
            exact
            path="/main/company/:company_id/projects/:id/flagged-items"
            element={<FlaggedItems />}
          ></Route>
          <Route
            exact
            path="/main/company/:company_id/projects/:id/view-dependencies"
            element={<ViewDependencies />}
          ></Route>
          <Route
            exact
            path="/main/company/:company_id/projects/:id/project-reports"
            element={<ProjectReports />}
          ></Route>
          <Route
            exact
            path="/main/company/:company_id/projects/:id/canned-reports"
            element={<Reports />}
          ></Route>
          <Route
            exact
            path="/main/company/:company_id/projects/:id/canned-reports/:reportName"
            element={<ReportsDetails />}
          ></Route>
          <Route
            exact
            path="/main/company/:company_id/projects/:id/project-custom-reports"
            element={<ProjectCustomReport />}
          ></Route>
          <Route
            exact
            path="/main/company/:company_id/projects/:id/project-custom-reports/:reportName"
            element={<CustomReportsDetails />}
          ></Route>
          <Route
            exact
            path="/main/company/:company_id/projects/:id/project-custom-reports/create-new-report"
            element={<CreateUpdateCustomReports mode="create" />}
          />
          <Route
            exact
            path="/main/company/:company_id/projects/:id/project-custom-reports/:reportName/edit"
            element={<CreateUpdateCustomReports mode="edit" />}
          />

          {/*  */}

          <Route
            exact
            path="/main/company/:company_id/company-overview"
            element={<CompanyOverview />}
          ></Route>
          <Route
            exact
            path="/main/company/:company_id/company-schedule"
            element={<CompanySchedule />}
          ></Route>
          <Route
            exact
            path="/main/company/:company_id/company-dashboard"
            element={<CompanyDashboard />}
          ></Route>
          <Route
            exact
            path="/main/company/:company_id/hilyte"
            element={<Hilyte />}
          ></Route>
          {/* <Route
            exact
            path="/main/company/:company_id/warehouse"
            element={<WareHouse />}
          ></Route>
          <Route
            exact
            path="/main/company/:company_id/warehouse-dashboard"
            element={<WarehouseDashboard />}
          ></Route> */}

          <Route path="main/company/:company_id" element={<WareHouse />}>
            <Route
              path="warehouse-dashboard"
              element={<WarehouseDashboard />}
            />
            <Route
              path="warehouse-inventory"
              element={<WarehouseInventory />}
            />
            <Route path="warehouse-job-sites" element={<WarehouseJobSites />} />
            <Route
              path="warehouse-transfers"
              element={<WarehouseTransfers />}
            />
            <Route path="warehouse-reports" element={<WarehouseReports />} />
            <Route
              path="warehouse-reports/:reportName"
              element={<WarehouseReportsDetails />}
            />
            <Route path="warehouse-settings" element={<WarehouseSettings />} />
            <Route
              path="warehouse-purchased-orders"
              element={<WarehousePurchasedOrders />}
            />
          </Route>

          {/*  */}

          {/*  */}

          <Route
            exact
            path="/main/company/:company_id/user-permission"
            element={<UserPermissionTable />}
          ></Route>
          <Route
            path="/main/company/:company_id/company-directory"
            element={<CompanyDirectory />}
          />
          <Route
            exact
            path="/main/company/:company_id/company-permission"
            element={<CompanyPermissions />}
          ></Route>
          <Route
            exact
            path="/main/company/:company_id/Project-permission"
            element={<ProjectPermissions />}
          ></Route>

          {/*  */}
          <Route
            path="/procurementLogEntry/:email/:entryID/:company_id/:id/:company_name/:project_name"
            element={<ContractorSubmittals />}
          ></Route>
          <Route
            path="/main/sidePanelSubmittal"
            element={<SidePanelSubmittals />}
          ></Route>
          {/* auth routes */}
          <Route exact path="/login" element={<Login />}></Route>
          <Route
            exact
            path="/handle-auth-data/:company_id/:company_name/:access_token/:refresh_token/:email"
            element={<HandleAuthData />}
          ></Route>
          <Route
            exact
            path="/forget-password"
            element={<ForgetPassword />}
          ></Route>
          <Route exact path="/verify-code" element={<VerifyCode />}></Route>
          <Route
            exact
            path="/resetPassword/:code"
            element={<ResetPassword />}
          ></Route>
          <Route
            exact
            path="/createPassword/:code"
            element={<CreatePassword />}
          ></Route>
          {/* intro routes */}
          <Route
            exact
            path="/KoncurentSupport"
            element={<KoncurentSupport />}
          ></Route>
          <Route
            exact
            path="/registering-new-client"
            element={<RegisterClient />}
          ></Route>
          <Route exact path="/about-us" element={<AboutUs />}></Route>
          <Route exact path="/contact-us" element={<ContactUs />}></Route>
          <Route exact path="/home" element={<Home />}></Route>
          <Route exact path="/" element={<Home />}></Route>
        </Routes>
        {/* <Footer /> */}
      </BrowserRouter>
    </>
  );
};

export default Router;
